module.exports = __webpack_public_path__ + "img/Icon_ionic-ios-close.139fc3a0.svg";